export class AddressInfo {


    public CitizenID: string;   
    public Address1: string;
    public AddressID: string;
    public RegAddrID: string;


}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/addressinfo.model.ts